import { FC } from 'react';
import {
  CollapsibleDividerProps,
  CollapsibleHeader,
} from '../../common/components/CollapsibleHeader';
import { DividerHeader } from '../../common/components/dividerHeader/DividerHeader';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { t } = i18nNsFactory('algorithm-form');

export interface AlgorithmHeaderProps extends CollapsibleDividerProps {
  algorithmId?: number;
  hideExpand?: boolean;
}

export const AlgorithmHeader: FC<AlgorithmHeaderProps> = (props) => {
  const { algorithmId, hideExpand = false, ...rest } = props;
  const isNew = !algorithmId || algorithmId < 0;

  return (
    <>
      {hideExpand ? (
        <DividerHeader
          {...rest}
          disabled={isNew}
          disabledLabel={t('tooltip.save')}
        />
      ) : (
        <CollapsibleHeader
          {...props}
          disabled={isNew}
          disabledLabel={t('tooltip.save')}
        />
      )}
    </>
  );
};
